import { SET_KEYBOARD_CLOSE, SET_KEYBOARD_OPEN } from "./keyboard-types";

export const setKeyboardVisible = (value) => (dispatch) => {
    const action = value ? SET_KEYBOARD_OPEN : SET_KEYBOARD_CLOSE
    console.log(action)
    dispatch({
        type: action,
        payload: value
      });
}